const numericTextDirective = (el, binding) => {
  const newValue = el.value.replace(/[^$\d.,]+/ig, '');
  el.value = newValue;
  binding.value = el.value;
};

export {
  numericTextDirective
};
